import PropTypes from 'prop-types';

// components
import { FormattedMessage } from 'dibs-react-intl';
import Checkmark from 'dibs-icons/exports/Checkmark';

// styles
import styles from './Benefits.scss';

function Benefit({ children }) {
    return (
        <div className={styles.benefit}>
            <Checkmark className={styles.icon} />
            <p className={styles.text}>{children}</p>
        </div>
    );
}

Benefit.propTypes = {
    children: PropTypes.node.isRequired,
};

export const benefitVetted = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.vetted"
            defaultMessage="Expertly Vetted Sellers"
        />
    </Benefit>
);

export const benefitProtection = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.protection"
            defaultMessage="Buyer Protection"
        />
    </Benefit>
);
export const benefitDelivery = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.delivery"
            defaultMessage="Insured Global Delivery"
        />
    </Benefit>
);

export const benefitPriceMatch = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.priceMatch"
            defaultMessage="Price-Match Guarantee"
        />
    </Benefit>
);

export const benefitConfidence = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.confidence"
            defaultMessage="Confidence at Checkout"
        />
    </Benefit>
);

export const benefitSupport = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.support"
            defaultMessage="Exceptional Support"
        />
    </Benefit>
);
